export default __webpack_public_path__ + "static/media/Occupancy.58df45f6.svg";